export const PLAN_COLORS = {
  custom: '#3987e5',
  pro: '#9085e9',
  ultimate: '#d4af37',
};

// Used only by the dashboard sidebar profile; the rest of the app keeps PLAN_COLORS.
export const SIDEBAR_PLAN_COLORS = {
  custom: '#594AFD',
  pro: '#AC27FF',
  ultimate: '#FFD700',
};

export const PLAN_LABELS = {
  custom: 'Custom',
  pro: 'Pro',
  ultimate: 'Ultimate',
};

export const DEFAULT_PLAN_COLOR = '#E3E3E3';
export const DEFAULT_PLAN_CIRCLE_COLOR = '#23232a';
